import { RootState } from '../redux';

export const selectAnalyzeReportStatus = (state: RootState) => state.suggestions.status;
export const selectExecutionId = (state: RootState) => state.suggestions.executionId;
export const selectLoadExecutionsSignedUrl = (state: RootState) => state.suggestions.signedUrl;

export const selectSuggestions = (state: RootState) => state.suggestions.suggestions;
export const selectReportBackgroundData = (state: RootState) => state.suggestions.reportBackgroundData;
export const selectActiveJurisdiction = (state: RootState) => state.suggestions.activeJurisdiction;
export const selectJurisdictions = (state: RootState) => state.suggestions.jurisdictions;

export const selectSuggestionCommentsCount = (state: RootState) => state.suggestions.suggestionCommentsCount;

export const fetchAnalysisLoadingState = (state: RootState) => state.suggestions.loading.fetchAnalyzeReportStatus;

export const selectLoadingPreviousAnalysisStatus = (state: RootState) => state.suggestions.loading.loadingPreviousAnalysisStatus;

export const selectAnalysisErrorMessage = (state: RootState) => state.suggestions.analysisErrorMessage;

export const selectDocumentId = (state: RootState) => state.suggestions.documentId;

export const selectDocumentSettings = (state: RootState) => state.suggestions.documentSettings;
